import config from '../config';

export const PROCEDURES_FEATURE = 'PROCEDURES';

const PROCEDURES_DIRECTORY = 'procedures';

export const PROCEDURES_MIMES = {
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  eml: 'message/rfc822',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  msg: 'application/vnd.ms-outlook',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  odt: 'application/vnd.oasis.opendocument.text',
  ots: 'application/vnd.oasis.opendocument.spreadsheet-template',
  ott: 'application/vnd.oasis.opendocument.text-template',
  pdf: 'application/pdf',
  png: 'image/png',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  svg: 'image/svg+xml',
  txt: 'text/plain',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export const MAX_SIZE_BYTES = 26214400;

const UNSAFE_FILENAME = /[\\/:*?"<>+;',`!|]/;

const UPLOAD_MUTATION = `mutation Upload($input: UploadInput!) {
  upload(input: $input) { fileId error }
}`;

export const extensionOf = (filename) => {
  if (!filename) return null;
  const lastDot = filename.lastIndexOf('.');
  if (lastDot <= 0 || lastDot === filename.length - 1) return null;
  return filename.slice(lastDot + 1).toLowerCase();
};

export const validate = (file) => {
  const extension = extensionOf(file.name);
  if (!extension) return `${file.name} has no file extension.`;
  if (!PROCEDURES_MIMES[extension]) return `${file.name} is not a supported file type.`;
  if (file.size > MAX_SIZE_BYTES) {
    return `${file.name} is larger than the ${MAX_SIZE_BYTES / (1024 * 1024)} MB limit.`;
  }
  return null;
};

export const safeName = (filename) => {
  const extension = extensionOf(filename);
  if (!extension) return filename;
  if (!UNSAFE_FILENAME.test(filename) && filename.length <= 255) return filename;
  return `upload.${extension}`;
};

export const uploadToDriveNext = async (file) => {
  const rejection = validate(file);
  if (rejection) return { error: rejection };

  const extension = extensionOf(file.name);
  const variables = { input: { feature: PROCEDURES_FEATURE, file: null } };

  const data = new FormData();
  data.append('operations', JSON.stringify({ query: UPLOAD_MUTATION, variables }));
  data.append('map', JSON.stringify({ 0: ['variables.input.file'] }));
  data.append('0', new Blob([file], { type: PROCEDURES_MIMES[extension] }), safeName(file.name));

  let response;
  try {
    response = await fetch(`${config.DRIVE_NEXT_URL}/graphql`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'apollo-require-preflight': 'true' },
      body: data,
    });
  } catch (error) {
    // fetch rejects when drive-next is unreachable; surface that like any other failed upload.
    return { error: `Unable to upload ${file.name}.` };
  }

  if (!response.ok) return { error: `Unable to upload ${file.name}.` };

  const payload = await response.json();
  const result = (payload.data && payload.data.upload) || {};
  if (payload.errors || result.error) {
    return { error: `Unable to upload ${file.name}.` };
  }
  if (!result.fileId) return { error: `Unable to upload ${file.name}.` };

  return {
    storageKey: `${PROCEDURES_DIRECTORY}/${result.fileId}`,
    origin: 'DRIVE_NEXT',
    contentType: PROCEDURES_MIMES[extension],
    filename: file.name,
  };
};
